<app-report-self-inspection-wrapper
  [data]="wrapperData"
  [showWaring]="showWarning"
  [isLoading$]="isLoading$"
>
  <app-text-input
    [data]="data.textData"
    [optionsButton]="false"
    (saveInput)="saveInput($event)"
    (markAsNA)="markAsNA.emit()"
    (undoSelfInspection)="undoSelfInspection.emit()"
    (hasUnsavedChanges)="handleHasUnsavedChanges($event)"
  />

  @if (!showWarning) {
    <app-file-handler
      [id]="data.id"
      [data]="data.fileData"
      (viewImages)="viewImages.emit()"
      (filesDownload)="filesDownload.emit($event)"
      (fileDelete)="fileDelete.emit($event)"
      (markAsNA)="markAsNA.emit()"
      (undoSelfInspection)="undoSelfInspection.emit()"
    />
  }
</app-report-self-inspection-wrapper>
